import VendorsCookieConsent from './cookie-consent/cookie-consent';

const vendors = () => {
	VendorsCookieConsent();
};

export default vendors;